export const environment = {
  production: true,
  serverAPI: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT',
  serverAPI1: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-sales-1.0-SNAPSHOT',
  serverAPI2: ' https://admin.halafresh.co.in/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT',
  serverAPI4: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-admin-1.0-SNAPSHOT',
  serverAPI5: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-pos-1.0-SNAPSHOT',
  serverAPI6: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-partner-1.0-SNAPSHOT',
  serverAPI7: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-deploy-1.0-SNAPSHOT',
  serverAPI8: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-whatsapp-1.0-SNAPSHOT',
  serverAPI9: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-crm-1.0-SNAPSHOT',
  serverAPI10: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-sequence-1.0-SNAPSHOT',
  serverAPI11: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-calling-1.0-SNAPSHOT',
  ImageAPI: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/small_image/200x170/',
  commonImageApi: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=',
  stepGuideImage: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/primary?fileName=',
  ImageAPI1: '/catalog/product/image/600x600/',
  thumnail: '/catalog/product/thumbnail/75x75/',
  ImageAPI2: '/catalog/product/small_image/200x170/',
  serverApINEw: 'http://localhost:8080',
  //commonImageApiNew: 'http://localhost:8086/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/common?fileName=',
  commonImageApiNew: 'https://admin.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/common?fileName=',
  firebase: {
    apiKey: "AIzaSyBpQyDhqnJf5Af5PX_MaET7MjDpJ5SEFVE",
    authDomain: "calsoft-one-live.firebaseapp.com",
    projectId: "calsoft-one-live",
    storageBucket: "calsoft-one-live.firebasestorage.app",
    messagingSenderId: "799294006486",
    appId: "1:799294006486:web:ec6af0b630b1fe29ba5577",
    measurementId: "G-10BYJZ530Q"
  },

}
